/* eslint-disable react/no-array-index-key */
import Skeleton from 'components/Skeleton';
import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import { withColorScheme } from 'redesignedComponents/decorators/withColorScheme';
import useStyles from 'redesignedComponents/sections/FAQ/styles';
import testIds from 'redesignedComponents/sections/FAQ/testIds';

const FAQSkeleton = () => {
  const colorScheme = useColorScheme();
  const styles = useStyles({ colorScheme });

  const renderingPageData = () => {
    return [...Array(4)].map((_, index) => (
      <div key={index} className={styles.skeletonSection}>
        <div>
          <div className={styles.skeletonTitle}>
            <Skeleton />
          </div>
          <div className={styles.skeletonIconWrapper}>
            <Skeleton />
          </div>
        </div>
        <div className={styles.skeletonContentWrapper}>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    ));
  };

  return (
    <div className={styles.root} data-testid={testIds.FAQRoot}>
      <div className={styles.mainContent} style={{ width: '100%' }}>
        {renderingPageData()}
      </div>
    </div>
  );
};

export default withColorScheme<unknown>(FAQSkeleton);
